import { render, staticRenderFns } from "./receivableAdjustmentComponent.vue?vue&type=template&id=37072c94&scoped=true&"
import script from "./receivableAdjustmentComponent.vue?vue&type=script&lang=js&"
export * from "./receivableAdjustmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./receivableAdjustmentComponent.vue?vue&type=style&index=0&id=37072c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37072c94",
  null
  
)

export default component.exports